import React from 'react';
/* import { UncontrolledTooltip } from 'reactstrap'; */

//components
/* import AddButton from '../../../components/AddButton'; */

// interface
import { ChatUserTypes } from '../../../data/chat';

// component
import ChatUser from './ChatUser';

interface DirectMessagesProps {
    users: Array<ChatUserTypes>;
    /* openAddContact: () => void; */
    selectedPersonChat: string | number;
    onSelectChat: (personId: number | string, conversationId: string) => void;
}
const DirectMessages = React.forwardRef(
    (
        {
            users,
            /* openAddContact, */
            selectedPersonChat,
            onSelectChat
        }: DirectMessagesProps,
        ref: React.ForwardedRef<HTMLLIElement>
    ) => {
        /* add contacts */
        return (
            <>
                <div className="d-flex align-items-center px-4 mt-2 mb-2">
                    <div className="flex-grow-1">
                        <h4 className="mb-0 font-size-11 text-muted text-uppercase">
                            Direct Messages
                        </h4>
                    </div>
                    {/* <div className="flex-shrink-0">
                        <div id="new-message" title="New Message">
                            <AddButton onClick={openAddContact} />{' '}
                        </div>
                        <UncontrolledTooltip
                            target="new-message"
                            placement="bottom"
                        >
                            New Message
                        </UncontrolledTooltip>
                    </div> */}
                </div>

                <div className="chat-message-list">
                    <ul className="list-unstyled chat-list chat-user-list">
                        {(users || []).map(
                            (user: ChatUserTypes, key: number) => {
                                if (ref && users.length === key + 1) {
                                    return (
                                        <ChatUser
                                            user={user}
                                            key={key}
                                            selectedPersonChat={
                                                selectedPersonChat
                                            }
                                            onSelectChat={onSelectChat}
                                            ref={ref}
                                        />
                                    );
                                } else {
                                    return (
                                        <ChatUser
                                            user={user}
                                            key={key}
                                            selectedPersonChat={
                                                selectedPersonChat
                                            }
                                            onSelectChat={onSelectChat}
                                        />
                                    );
                                }
                            }
                        )}
                    </ul>
                </div>
            </>
        );
    }
);

export default DirectMessages;
